import { Button, Flex, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react"
import moment from "moment"
import { FC } from "react"
import { DeleteIconButton } from "src/components/ui/iconButtons/DeleteIconButton"
import { EditIconButton } from "src/components/ui/iconButtons/EditIconButton"
import { IHallBooking } from "src/domain/entities"

export const HallBookingListView: FC<{
	list: IHallBooking[]
	onUpdate: (item: IHallBooking) => void
	onDelete: (item: IHallBooking) => void
	onAddBill: (item: IHallBooking) => void
	onViewBill: (item: IHallBooking) => void
	onEditBill: (item: IHallBooking) => void
	onDeleteBill: (item: IHallBooking) => void
}> = ({ list, onUpdate, onDelete, onAddBill, onViewBill, onEditBill, onDeleteBill }) => (
	<Table size={"sm"}>
		<Thead>
			<Tr>
				<Th>Start Date</Th>
				<Th>End Date</Th>
				<Th>Reason</Th>
				<Th>Contact</Th>
				<Th>Location</Th>
				<Th>Deposit</Th>
				<Th>Payment Remarks</Th>
				<Th>Bill</Th>
				<Th isNumeric>Actions</Th>
			</Tr>
		</Thead>
		<Tbody>
			{list.map((item, i) => (
				<Tr key={i}>
					<Td>{moment(item.startDate).format("DD/MM/YYYY")}</Td>
					<Td>{moment(item.endDate).format("DD/MM/YYYY")}</Td>
					<Td>{item.reason}</Td>
					<Td>
						{item.contact?.firstName} {item.contact?.lastName}
					</Td>
					<Td>{item.location?.name}</Td>
					<Td>{item.deposit}</Td>
					<Td>{item.paymentRemarks}</Td>
					<Td>
						{item.bill ? (
							<Flex gap={2} alignItems="center">
								<Button size="sm" onClick={() => onViewBill(item)}>
									View
								</Button>
								<EditIconButton
									onClick={() => onEditBill(item)}
									aria-label="Edit bill"
								/>
								<DeleteIconButton
									onClick={() => onDeleteBill(item)}
									aria-label="Delete bill"
								/>
							</Flex>
						) : (
							<Button size="sm" onClick={() => onAddBill(item)}>
								Add Bill
							</Button>
						)}
					</Td>
					<Td isNumeric>
						<EditIconButton onClick={() => onUpdate(item)} />
						<DeleteIconButton onClick={() => onDelete(item)} />
					</Td>
				</Tr>
			))}
		</Tbody>
	</Table>
)
